import { render, staticRenderFns } from "./oneStatistics.vue?vue&type=template&id=7a63b77c&scoped=true&"
import script from "./oneStatistics.vue?vue&type=script&lang=js&"
export * from "./oneStatistics.vue?vue&type=script&lang=js&"
import style0 from "./oneStatistics.vue?vue&type=style&index=0&id=7a63b77c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a63b77c",
  null
  
)

export default component.exports